export default "__VITE_ASSET__CQ6T49wT__"